import { render, staticRenderFns } from "./supplierDetail.vue?vue&type=template&id=7296b1b4&scoped=true"
import script from "./supplierDetail.vue?vue&type=script&lang=js"
export * from "./supplierDetail.vue?vue&type=script&lang=js"
import style0 from "./supplierDetail.vue?vue&type=style&index=0&id=7296b1b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7296b1b4",
  null
  
)

export default component.exports